module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'relationship'
    ],

    config: {
        bootstrapVersion: 5,
        relationContainerConfigExtension: {
            bootstrapVersion: 5,
        },

        defaultSubFormComponent: [
            '/',
            'base',
            'bootstrap5',
            'form',
            'form'
        ],
    }
}
